/**
 * @fileOverView
 * @description Peep View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var PeepTemplate = require('../../templates/widgets/peeptemplate.html');
var app = require('ampersand-app');
var dialog = require('../../lib/dialog');

var PeepView = AmpersandView.extend({
    template: PeepTemplate,

    render: function(){
        this.renderWithTemplate();
    },

    bindings: {
        "model.name": {
            type: 'text',
            hook: 'name'
        },
        "model.statusDisplay" : {
            type: "innerHTML",
            hook: "status"
        }
    },

    events: {
        "click [data-hook=remove]" : "removePeep",
    },

    removePeep: async function(){
        var msg = "Remove this peep?";
        var okText = "Remove";
        if(this.model.accessStatus=="invited"){
            msg = "Revoke invitation?";
            okText = "Revoke";
        }
        if(await dialog.confirm(msg, {okText: okText, danger: true})){
            app.tmpDisableScroll = true;
            this.model.destroy();
        }
    }

});

module.exports = PeepView;
